import styled from 'styled-components';

import { VfoBarChart, WidgetContainer } from '@/features/vfo/components';
import { breakpoints } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';

export const TaskStatisticsWrapper = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  padding: 12px;

  @container ${breakpoints.sm} {
    flex-direction: row;
    gap: 8px;
    border-bottom: 1px solid ${COLORS.systemDark50A};
    padding: 12px 0;
  }
`;

export const WidgetContainerStyled = styled(WidgetContainer)`
  && {
    @container ${breakpoints.sm} {
      padding: 0;
      flex: 1;

      .titleWrapper {
        flex-direction: column;
        gap: 6px;
        text-align: center;
        font-size: 12px;
      }
    }
  }
`;

export const ChartsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;

  @container ${breakpoints.sm} {
    gap: 12px;
  }
`;

export const VfoBarChartStyled = styled(VfoBarChart)`
  flex: 1;
  width: 33%;

  @container ${breakpoints.sm} {
    padding: 12px 0 0 0;
    border-top: 1px solid ${COLORS.systemDark50A};
    border-radius: 0;
  }
`;

export const NoJobsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
  color: ${COLORS.systemDark200};
  height: 100%;
`;
